import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/(ACTIVITY)/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"],\"variable\":\"--font-roboto\",\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/(ACTIVITY)/layout.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AmplitudeInitializer.tsx");
